export default [
  {
    path: '/orders/create',
    name: 'OrderCreate',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/OrderCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Crear orden'
    }
  },
  {
    path: '/orders/:id',
    name: 'OrderRetrieve',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/OrderRetrieve.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Orden'
    }
  },
  {
    path: '/orders',
    name: 'OrderList',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/OrderList.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Órdenes'
    }
  },
  {
    path: '/orders/:id/edit',
    name: 'OrderUpdate',
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/OrderCreate.vue'),
    meta: {
      displayAppBar: true,
      displayNavigationDrawer: true,
      displayNavigation: true,
      displayOrganization: true,
      parent: 'InvoiceList',
      requireAuth: true,
      requireAccount: true,
      title: 'Editar orden'
    }
  }
]